import React, { FC, ChangeEvent } from "react";

export interface ValdatedInputProps {
  label?: string;
  type?: string;
  placeholder?: string;
  name: string;
  errorMessage?: string;
  handleChange?: (event: ChangeEvent) => void;
  classname?: string;
  register?: (ref: string, { required: boolean, pattern: RegExp }) => void;
  pattern?: RegExp;
  value?: string;
}

export const ValidatedInput: FC<ValdatedInputProps> = ({
  label,
  type = "text",
  placeholder,
  name,
  handleChange,
  errorMessage,
  classname,
  register,
  pattern,
  value,
}) => (
  <>
    {!!label && (
      <label htmlFor={name} className="required">
        {label}
      </label>
    )}
    <input
      className={classname}
      id={label && name}
      type={type}
      name={name}
      placeholder={placeholder}
      onChange={handleChange}
      value={value}
      {...register(name, { required: true, pattern })}
    />
    {!!errorMessage && <p className="error">{errorMessage}</p>}
  </>
);
